export default {"src":"/_next/static/media/floating-apy.62f8d202.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};